import { render } from "./App.vue?vue&type=template&id=6dea1d24"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6dea1d24&lang=css"
script.render = render

export default script